<template>
  <table class="w-full">
    <thead>
      <tr>
        <th>Name</th>
        <th>Email</th>
        <th>Phone</th>
        <th>Approved By</th>
      </tr>
    </thead>
    <tbody class="rounded-md border-2">
      <tr
        v-for="(request, index) in completedRequests"
        :key="index"
        class="py-2"
      >
        <td>
          <span
            >{{ request.user?.first_name }} {{ request.user?.last_name }}</span
          >
        </td>
        <td>
          <span> {{ request.user?.email }}</span>
        </td>
        <td>
          <span>
            {{ formattedPhone(request?.user?.phone_e164) }}
          </span>
        </td>
        <td>
          <span>
            {{
              request.approver?.first_name ? request.approver.first_name : '-'
            }}
            {{ request.approver?.last_name ? request.approver.last_name : '-' }}
            <br /><span class="text-1xs">{{
              request.approved_at ? formatDate(request.approved_at) : '-'
            }}</span></span
          >
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import WordTools from '@/mixins/wordTools';
import dayjs from 'dayjs';
import { formatPhoneParenthesis } from '@/common/validators';

export default {
  name: 'InvitationsTable',
  mixins: [WordTools],
  props: {
    completedRequests: Object,
  },
  computed: {
    formattedPhone() {
      return (phone) => {
        return formatPhoneParenthesis(phone);
      };
    },
  },
  methods: {
    formatDate(date) {
      return dayjs(date).format('M/D/YY');
    },
  },
};
</script>
<style scoped>
.tabs-item {
  @apply block w-full text-xs font-medium uppercase leading-tight;
  @apply my-2 px-6 py-3;
  @apply hover:bg-gray-100;
}
small {
  @apply text-xxs !important;
}
.btn-disabled {
  @apply hover:bg-white !important;
}

table {
  border-collapse: separate;
  border-spacing: 0;
  background: white;
  border-radius: 10px;
  font-size: 12px;
  /* border: 1px solid rgb(237, 237, 240); */
}
table tr td {
  color: #6d7181;
  padding: 15px;
}
thead {
  background: white;
  padding: 10px 10px 10px 0;
  height: 40px;
  margin-top: 10px;
}
tbody {
  box-shadow: 0 0 0 1px rgb(237, 237, 240);
  border-radius: 10px;
  z-index: 4;
}

th {
  padding: 10px 10px 0 15px;
}
table tr:first-child td:first-child {
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
table tr:first-child td:last-child {
  border-top-right-radius: 15px;
}
table tr:last-child td:first-child {
  border-bottom-left-radius: 15px;
}
table tr:last-child td:last-child {
  border-bottom-right-radius: 15px;
}
</style>
